import React, {Component} from 'react';
import {inject, observer} from 'mobx-react';
import ReservationHeader from "../components/ReservationHeader";

@inject('packageStore')
@inject('reservationStore')
@observer
export default class ReservationResultPage extends Component {

  constructor(props) {
    super(props);

    this.state = {
      reservationResult: {}
    }
  }

  componentDidMount() {
    const {reservationStore, location, } = this.props;
    const {pin} = location.state;

    reservationStore.setReservationResult(pin).then(res => {
      if(res.code === 200 && res.body) {
        this.setState({ reservationResult: res.body });
      } else {
        alert('예약 조회를 할 수 없습니다.\n판매처에 문의 부탁드립니다.');
      }
    });
  }

  render() {

    const {barcode} = this.props.location.state;
    const { reservationResult } = this.state;

    return (
      <div>
        <ReservationHeader
          tab={'result'}
          barcode={barcode}
        />
        <div className="App-container">
          <div className="group-items">
            <form>
              <div className="box-item" style={{marginBottom: '100px', paddingBottom: '50px', textAlign: 'left'}}>
                <h3 className="item-title">예약된 정보</h3>
                <div
                  className="item-content"
                  style={{height: '50px', borderBottom: '1px solid #d8d8d8', paddingLeft: '20px', lineHeight: '50px'}}
                >이름: {reservationResult.customNm && reservationResult.customNm}</div>
                <div
                  className="item-content"
                  style={{height: '50px', borderBottom: '1px solid #d8d8d8', paddingLeft: '20px', lineHeight: '50px'}}
                >핸드폰 번호: {reservationResult.customCell}</div>
                <div
                  className="item-content"
                  style={{height: '50px', borderBottom: '1px solid #d8d8d8', paddingLeft: '20px', lineHeight: '50px'}}
                >예약 날짜 : {reservationResult.reserveDate}</div>
                <div
                  className="item-content"
                  style={{height: '50px', borderBottom: '1px solid #d8d8d8', paddingLeft: '20px', lineHeight: '50px'}}
                >예약 내용</div>
                <div
                  className="item-content"
                  style={{height: '100%', borderBottom: '1px solid #d8d8d8', paddingLeft: '20px', lineHeight: '50px'}}
                >{
                  reservationResult.reservePath
                  && reservationResult.reservePath.length > 0
                  && reservationResult.reservePath.map((path, index) => {
                    return <div>{index + 1}. {path}</div>
                  })
                }</div>
              </div>
            </form>
          </div>
        </div>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/pages/ReservationResultPage.jsx